import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

//material ui
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import AttachFileIcon from '@material-ui/icons/AttachFile';

import GDPRHint from '../GDPRHint';

import UploadGpxFileMutation from '../../../mutations/UploadGpxFileMutation';

import environment from '../../../environment';

class ExtendedSearchGpsSearchTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null,
      showFileExtensionError: false,
      showFileSizeError: false,
      showSearchBtn: false,
      isUploading: false,
    };
  }

  handleFileChanged = event => {
    const selectedFile = event.target.files[0];

    // 'selectedFile' can be undefined if no file has been selected in the file manager
    if (selectedFile) {
      // Check if the file selected by the user is a "gpx" file)
      if (checkFileExtension(selectedFile.name, 'gpx')) {
        this.setState({
          selectedFile,
          showFileExtensionError: false,
          showFileSizeError: false,
          showSearchBtn: true,
        });
      } else {
        this.setState({
          selectedFile: null,
          showFileExtensionError: true,
          showFileSizeError: false,
          showSearchBtn: false,
        });
        return;
      }

      // The backend currently supports file uploads up to 20.000.000 bytes.
      if (selectedFile.size > 20000000) {
        this.setState({
          selectedFile: null,
          showFileExtensionError: false,
          showFileSizeError: true,
          showSearchBtn: false,
        });
      }
    }
  };

  handleUploadGpxFile = () => {
    this.setState({ isUploading: true });
    const { eventId, startnumber, onNavigateTo } = this.props;

    UploadGpxFileMutation.commit(
      environment,
      this.state.selectedFile,
      (error, fileId) => {
        if (error) {
          this.setState({ isUploading: false });
        } else {
          this.setState({ isUploading: false }, () => {
            onNavigateTo(`/event/${eventId}/gps/${fileId}/${startnumber}`);
          });
        }
      }
    );
  };

  render() {
    const {
      selectedFile,
      isUploading,
      showFileExtensionError,
      showFileSizeError,
      showSearchBtn,
    } = this.state;

    return (
      <div className="extended-search-gpssearch-container">
        <div>
          <h2>
            <FormattedMessageWrappedInSpan
              id="extendedSearchGpsSearchTab.ownSearch.title"
              defaultMessage="Search with your GPS data"
            />
          </h2>
          <p>
            <FormattedMessageWrappedInSpan
              id="extendedSearchGpsSearchTab.ownSearch.description"
              defaultMessage="Upload your GPX file and we will show your photos"
            />
          </p>
          <div>
            <Button classes={{ root: 'gps-search-upload-btn' }}>
              <AttachFileIcon />
              {selectedFile ? (
                <span>
                  {selectedFile.name}
                </span>
              ) : (
                <FormattedMessageWrappedInSpan
                  id="extendedSearchGpsSearchTab.ownSearch.uploadButton"
                  defaultMessage="Choose a file"
                />
              )}
              <input type="file" onChange={this.handleFileChanged} />
            </Button>
          </div>
          {showFileExtensionError && (
            <p className="file-extension-error">
              <FormattedMessageWrappedInSpan
                id="extendedSearchGpsSearchTab.ownSearch.fileExtensionError"
                defaultMessage="The file should have the following extension: .gpx"
              />
            </p>
          )}
          {showFileSizeError && (
            <p className="file-extension-error">
              <FormattedMessageWrappedInSpan
                id="extendedSearchGpsSearchTab.ownSearch.fileSizeError"
                defaultMessage="The file is too big. We currently support file uploads up to 20 MB."
              />
            </p>
          )}
          {isUploading && <CircularProgress />}
          {!isUploading && showSearchBtn && (
            <button className="primary" onClick={this.handleUploadGpxFile}>
              <FormattedMessageWrappedInSpan
                id="extendedSearchGpsSearchTab.ownSearch.searchButton"
                defaultMessage="Search"
              />
            </button>
          )}
          <GDPRHint className="mt-30" />
        </div>
      </div>
    );
  }
}

const checkFileExtension = (filename, extension) => {
  var regex = new RegExp('.' + extension + '$', 'ig');
  return regex.test(filename);
};

ExtendedSearchGpsSearchTab.propTypes = {
  eventId: PropTypes.number,
  startnumber: PropTypes.string,
  onNavigateTo: PropTypes.func,
};

export { ExtendedSearchGpsSearchTab };

export default ExtendedSearchGpsSearchTab;
